var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M932 706L930.833 704.937M930.833 704.937L909.5 685.5L943.5 491.5H950.5V488H956.5V486H966V491.5L971 488L973 486H989.5V491.5H997.5V488H1004L1011 491.5L1019.5 493V499H1031L1037 504.5V493H1041.5L1046 491.5H1054.5L1055.5 494.5H1071.5V491.5H1083L1088.5 494.5L1090 500V513.5H1111L1111.5 497.5L1113.5 494.5H1119V491.5H1128V494.5L1146 493V491.5H1154L1156 494.5H1162L1164.5 500V511H1183L1185 486L1239.5 480.5L1242.5 491.5V502H1267L1271.5 464.5H1288V469H1290.5V462L1309.5 464.5L1305 508.5L1318.5 511L1322 475.5L1327.5 473.5L1332 475.5L1342 480.5H1346L1356 488V502L1364.5 504.5L1377 520L1375 547L1386.5 559.5L1400 584.5H1404.5L1426.5 649L1453.5 736L1327.5 721.5L1229 711H1108.5L1055.5 714L1016 708L930.833 704.937Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase3);
export default __webpack_public_path__ + "static/media/phase_3.fa2433512640146d68f1fc4e07415793.svg";
export { ForwardRef as ReactComponent };